/* pamela-panels-registry.js
   Dynamic Panels / Frames registry from Render SVG library
*/

window.PAMELA_PANELS = [];
window.PAMELA_PANELS_CATEGORIES = [];
window.PAMELA_PANELS_TABS = {
  "Last Name": ["Book", "Heart", "Misc", "Oval", "Rectangle", "Ribbon", "Scroll"],
  "Name/Dates": ["Book", "Heart", "Misc", "Oval", "Rectangle", "Ribbon", "Scroll"],
  "Verse": ["Book", "Heart", "Misc", "Oval", "Rectangle", "Ribbon", "Scroll"],
};

(function () {
  const API_BASE =
    window.CM_SVG_API_BASE ||
    "https://cm-editor-server.onrender.com";

  function toTitleCase(s) {
    return String(s || "")
      .replace(/[-_]+/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase()
      .replace(/\b\w/g, (m) => m.toUpperCase());
  }

  function normalizeGroup(raw) {
    const s = String(raw || "").trim().toLowerCase();

    if (s === "last name") return "Last Name";
    if (s === "lastname") return "Last Name";

    if (s === "name/dates") return "Name/Dates";
    if (s === "name-dates") return "Name/Dates";
    if (s === "name dates") return "Name/Dates";

    if (s === "verse") return "Verse";

    return toTitleCase(raw) || "Panels";
  }

  function normalizeSubcat(raw) {
    const s = String(raw || "").trim().toLowerCase();

    if (s === "name/dates") return "Name/Dates";
    if (s === "name-dates") return "Name/Dates";
    if (s === "last name") return "Last Name";

    return toTitleCase(raw) || "General";
  }

  function normalizePanelItem(item) {
    const group = normalizeGroup(item?.category || item?.group || "");
    const subcat = normalizeSubcat(item?.subcategory || item?.subcat || "");

    return {
      ...item,
      id: String(item?.id || "").trim(),
      name: String(item?.name || item?.id || "").trim(),
      group,
      subcat,
      category: `${group} — ${subcat}`,
      url: String(item?.url || "").trim().startsWith("http")
        ? String(item?.url || "").trim()
        : API_BASE.replace(/\/+$/, "") + "/" + String(item?.url || "").trim().replace(/^\/+/, ""),
    };
  }

  async function loadPanelsFromRender() {
    try {
      const url = API_BASE.replace(/\/+$/, "") + "/api/panel-library";
      const res = await fetch(url, { credentials: "omit" });

      if (!res.ok) {
        throw new Error(`Panel library fetch failed (${res.status})`);
      }

      const data = await res.json();
      const items = Array.isArray(data) ? data.map(normalizePanelItem) : [];

      window.PAMELA_PANELS = items;
      window.PAMELA_PANELS_CATEGORIES = items.map((it) => it.category);

      window.dispatchEvent(new CustomEvent("pamela:panels-registry-loaded", {
        detail: { count: items.length }
      }));

      console.log("[Panels Registry] Loaded from Render:", items.length);
    } catch (e) {
      console.error("[Panels Registry] Failed to load panel library:", e);
      window.PAMELA_PANELS = [];
      window.PAMELA_PANELS_CATEGORIES = [];
    }
  }

  loadPanelsFromRender();
})();
